import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _containers, _BreadcrumbsService_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";
import { warn } from "@ember/debug";
import Service from "@ember/service";
let BreadcrumbsService = (_class = (_containers = /*#__PURE__*/new WeakMap(), _BreadcrumbsService_brand = /*#__PURE__*/new WeakSet(), class BreadcrumbsService extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _BreadcrumbsService_brand);
    _initializerDefineProperty(this, "containers", _descriptor, this);
    _classPrivateFieldInitSpec(this, _containers, []);
  }
  registerContainer(container) {
    if (_assertClassBrand(_BreadcrumbsService_brand, this, _isContainerRegistered).call(this, container)) {
      (false && warn("[BreadcrumbsService] A breadcrumb container with the same DOM element has already been registered before."));
    }
    _classPrivateFieldSet(_containers, this, [..._classPrivateFieldGet(_containers, this), container]);
    this.containers = _classPrivateFieldGet(_containers, this);
  }
  unregisterContainer(container) {
    if (!_assertClassBrand(_BreadcrumbsService_brand, this, _isContainerRegistered).call(this, container)) {
      (false && warn("[BreadcrumbsService] No breadcrumb container was found with this DOM element."));
    }
    _classPrivateFieldSet(_containers, this, _classPrivateFieldGet(_containers, this).filter(registeredContainer => {
      return container.element !== registeredContainer.element;
    }));
    this.containers = _classPrivateFieldGet(_containers, this);
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "containers", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
})), _class);
function _isContainerRegistered(container) {
  return _classPrivateFieldGet(_containers, this).some(registeredContainer => {
    return container.element === registeredContainer.element;
  });
}
export { BreadcrumbsService as default };